import { useState, useDebugValue } from 'react';

const useStateLabel = (initialValue, name) => {
  const [value, setValue] = useState(initialValue);
  useDebugValue(`${name}: ${value}`);
  return [value, setValue];
};

export { useStateLabel };
